import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Star, Save } from "lucide-react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export const CsatSection = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings").then((r) => r.data) });
  const [f, setF] = useState(null);
  useEffect(() => { if (data && !f) setF(data); }, [data, f]);
  if (!f) return null;
  const save = async (patch = {}) => {
    try {
      const { data: s } = await api.put("/settings", { csat_enabled: f.csat_enabled, csat_message: f.csat_message, csat_thanks: f.csat_thanks, ...patch });
      qc.setQueryData(["settings"], s);
      toast.success("Sondaggio di soddisfazione salvato");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="bg-white border border-slate-200 rounded-xl" data-testid="csat-section">
      <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-3">
        <span className="w-9 h-9 rounded-lg bg-amber-50 text-amber-600 grid place-items-center"><Star size={17} /></span>
        <div><h3 className="font-semibold text-slate-900">Sondaggio di soddisfazione</h3><p className="text-xs text-slate-500">Invialo a mano dal pulsante ★ Sondaggio nella chat. Se attivi l'interruttore parte anche in automatico alla chiusura.</p></div>
        <div className="ml-auto flex items-center gap-2">
          <span data-testid="csat-status-label" className={`text-xs font-semibold ${f.csat_enabled ? "text-[#15803D]" : "text-slate-400"}`}>{f.csat_enabled ? "Automatico" : "Solo manuale"}</span>
          <Switch data-testid="csat-toggle-switch" checked={f.csat_enabled} onCheckedChange={(v) => { setF({ ...f, csat_enabled: v }); save({ csat_enabled: v }); }} className="data-[state=checked]:bg-[#25D366]" />
        </div>
      </div>
      <div className="p-6 space-y-4">
        <div className="space-y-1.5">
          <Label>Domanda inviata al cliente</Label>
          <Textarea data-testid="csat-message-textarea" rows={7} value={f.csat_message} onChange={(e) => setF({ ...f, csat_message: e.target.value })} />
        </div>
        <div className="space-y-1.5">
          <Label>Messaggio di ringraziamento</Label>
          <Textarea data-testid="csat-thanks-textarea" rows={2} value={f.csat_thanks} onChange={(e) => setF({ ...f, csat_thanks: e.target.value })} />
        </div>
        <p className="text-[11px] text-slate-400">Usa <code>{"{azienda}"}</code> per il nome dell'azienda. Il sondaggio parte solo se l'ultimo messaggio del cliente è entro 24 ore; la valutazione resta valida per 24 ore e non riapre la chat.</p>
        <div className="flex justify-end"><Button data-testid="csat-save-button" onClick={() => save()} className="bg-[#0F172A] hover:bg-[#1E293B]"><Save size={15} className="mr-1.5" />Salva</Button></div>
      </div>
    </section>
  );
};
